import { render, staticRenderFns } from "./ViewStorageFile.vue?vue&type=template&id=42467a4d&scoped=true&"
import script from "./ViewStorageFile.vue?vue&type=script&lang=js&"
export * from "./ViewStorageFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42467a4d",
  null
  
)

export default component.exports